let x = 0, y = 0;

$(document).ready(function () {
    /**
     * Блокировка скролла
     */
    function noScroll() {
        window.scrollTo(x, y);
    }

    /**
     * Функция открытия попапа
     */
    function openPopup($popup) {
        x = window.pageXOffset;
        y = window.pageYOffset;
        window.addEventListener('scroll', noScroll);
        $popup.find('.popup').css({bottom: '-100%', opacity: 1});
        $popup.find('.button_close').css({display: 'none'});

        $popup.fadeToggle(function () {
            $popup.find('.popup').animate({
                bottom: '0%'
            }, 400, function () {
                $popup.find('.button_close').fadeToggle(function () {
                    $popup.find('.popup-img').animate({
                        opacity: 1
                    }, 200, function () {
                        $('.popup-wrap').animate({
                            opacity: 1
                        }, 300)
                    });
                });
            });
        });
    }

    /**
     * Функция закрытия попапа
     */
    function closePopup($popup) {
        $popup.find('.button_close').fadeToggle(function () {
            $popup.find('.popup-img').animate({
                opacity: 0
            }, 200, function () {
                $('.popup-wrap').animate({
                    opacity: 0
                }, 200, function () {
                    $popup.find('.popup').animate({bottom: '-100%'}, 300, function () {
                        $popup.fadeOut();
                    });
                })
            });
        });

        // $popup.fadeToggle();
        window.removeEventListener('scroll', noScroll);
    }

    // Переключение между типами корнеров
    $('body').on('click', '.shop-selector__button', function () {
        if ($(this).hasClass('link')) {
            return;
        }

        if (!$(this).hasClass('active')) {
            $('.shop-selector__button').removeClass('active');
            $(this).addClass('active');

            $('.shop-content').fadeToggle();
        }
    });

    // Открытие попапа корнера
    $('body').on('click', '.shop-content__item, .floors__map-marker, .floors__list-item', function () {
        const id = $(this).data('id');

        $.ajax({
            url: '/site/get-corner-info',
            data: {
                id: id
            },
            success: function (data) {
                if (data.success) {
                    $('.corner-popup').html(data.html);
                    openPopup($('.corner-popup'));
                } else {
                    alert('Произошла ошибка! Повторите операцию позднее');
                }
            },
            error: function () {
                alert('Произошла ошибка! Повторите операцию позднее');
            }
        });
    });

    // Закрытие попапа корнера
    $('body').on('click', '.close-corner-popup', function () {
        closePopup($('.corner-popup'))
    });

    // Закрытие попапа новости
    $('body').on('click', '.close-news-message-popup', function () {
        closePopup($('.news-message-popup'));
    });

    // Открытие попапа обратной связи
    $('.contacts-button').on('click', function () {
        ym(55832245, 'reachGoal', 'FORM');
        openPopup($('.contacts-form__overlay'));
    });

    // Закрытие попапа обратной связи
    $('.close-contacts-popup').on('click', function () {
        closePopup($('.contacts-form__overlay'));
        // $.pjax.reload({container: '#contacts-form', async: false});
    });

    // Скролл к элементу
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    // Переключение этажей
    $('body').on('click', '.floors__headers-item', function () {
        if ($(this).hasClass('active')) {
            return false;
        }

        const currentFloor = $(this).data('floor');
        const activeFloor = $('.floors__headers-item.active').data('floor');

        $('.floors__headers-item.active').toggleClass('active');
        $(this).toggleClass('active');

        // Скрываем маркеры на текущем этаже
        $(`#floor-${activeFloor}`).find('.floors__map-marker').each(function () {
            $(this).removeClass('active');
        });

        $(`#floor-${activeFloor}`).hide();
        $(`#floor-${currentFloor}`).show(0, function () {
            $(`#floors__list-flor-${activeFloor}`).fadeToggle(function () {
                $(`#floors__list-flor-${currentFloor}`).fadeToggle();

                $(`#floor-${currentFloor}`).find('.floors__map-marker').each(function () {
                    $(this).delay(100).addClass('active');
                });
            });
        });
    });

    // Переключение списков корнеров по клику по кнопке в шапке
    $('.set-corner-list-active').on('click', function () {
        const currentListId = $(this).data('target');
        const activeListId = currentListId === 'shop-selector-eat' ? 'shop-selector-buy' : 'shop-selector-eat';

        if (activeListId === currentListId || $(this).hasClass('active')) {
            return false;
        }

        $('.set-corner-list-active').removeClass('active');
        $(this).addClass('active');

        $(`#${activeListId}-content`).fadeToggle();
        $(`#${currentListId}-content`).fadeToggle();

        $(`#${currentListId}`).removeClass('active');
        $(`#${activeListId}`).addClass('active');
    });

    // Успешная отправка формы обратной связи
    $('#contacts-form').on('pjax:success', function() {


        $('.contacts-form__cat').fadeOut(function () {
            $('.contacts-form__form').fadeOut(function () {
                $('.contacts-form__head').fadeToggle(function () {
                    $('.contacts-form__head h1').text('Ваше письмо было успешно отправлено!');
                    $('.contacts-form__head').fadeToggle();
                });
            });
        });
    });

    /**
     * Разворачивание мобильного меню
     */
    $('.header-nav-icon').on('click', function () {
        $('.mobile-menu').slideToggle();
    });

    /**
     * Сворачивание мобильного меню
     */
    $('.mobile-menu__close').on('click', function () {
        $('.mobile-menu').slideToggle();
    });

    /**
     * Кнопка "Показать все" в списке корнеров
     */
    $('.show-all-markers').on('click', function () {
        $contentBlock = $(this).parent();

        $(this).fadeOut(function () {
            $('.shop-content-block').fadeIn().css({display: 'flex'});
            $('.shop-content__item').fadeIn().css({display: 'flex'});
            $('.show-all-markers').addClass('hidden');
        });
    });

    /**
     * Кнопка "Показать все" в списке новостей
     */
    $('.show-all-news-button').on('click', function () {
        $(this).fadeOut(function () {
            $('.news-item').fadeIn().css({display: 'flex'});
        });
    });

    /**
     * Отображение маркера при наведении
     */
    $('.floors__map-marker-icon').on('mouseenter', function (e) {
        let $marker = $(this).parent();
        $marker.find('.floors__map-marker-preview').css({display: 'block'});
        $marker.find('.floors__map-marker-preview').animate({
            opacity: 1
        }, 100);
        $marker.addClass('hovered');
    });

    $('.floors__map-marker-icon').on('mouseleave', function (e) {
        let $marker = $(this).parent();
        $marker.find('.floors__map-marker-preview').animate({
            opacity: 0
        }, 100, function () {
            $marker.find('.floors__map-marker-preview').css({display: 'none'});
            $marker.removeClass('hovered');
        });
    });

    let rellax = new Rellax('.rellax');

    let down = false;
    let scrollLeft = 0;
    let isNewsScrolling = false;
    let x = 0;

    $('.news-line').mousedown(function(e) {
        down = true;
        scrollLeft = this.scrollLeft;
        x = e.clientX;
    }).mouseup(function() {
        down = false;
    }).mousemove(function(e) {
        if (down) {
            this.scrollLeft = scrollLeft + x - e.clientX;
            isNewsScrolling = true;
        }
    }).mouseleave(function() {
        down = false;
    });


    // Открытие попапа новости
    $('.news-item').on('click', function () {
        if (isNewsScrolling) {
            isNewsScrolling = false;
            return false;
        }

        const id = $(this).data('id');

        $.ajax({
            url: '/site/get-new-message-info',
            data: {
                id: id
            },
            success: function (data) {
                if (data.success) {
                    $('.news-message-popup').html(data.html);
                    openPopup($('.news-message-popup'));
                } else {
                    alert('Произошла ошибка! Повторите операцию позднее');
                }
            },
            error: function () {
                alert('Произошла ошибка! Повторите операцию позднее');
            }
        });


        window.addEventListener('scroll', noScroll);
    });
});

$('a[href^="#"]').on('click', function(event) {
    var hash = '#' + $(this).attr('href').split('#')[1];
    if (hash === '#') {
        return false;
    }

    var element = $(hash)
    if (element.length) {
        event.preventDefault();
        history.pushState(hash, undefined, hash)
        $('html, body').animate({scrollTop: element.offset().top}, 800)
    }
});

window.addEventListener('popstate', function(e) {
    if(e.state && e.state.startsWith('#') && $(e.state).length){
        $('html, body').animate({scrollTop: $(e.state).offset().top}, 800)
    }
});

$('html, body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
    $('html, body').stop();
});